import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Terms from "./pages/Terms";
import Help from "./pages/Help";
import Book from "./pages/book";
import BookPHXHyattRegencyDWT from "./pages/BookPHXHyattRegencyDWT";
import BookPHXHyattAdvancedrez from "./pages/BookPHXHyattAdvancedrez";
import BookJavitsAdvancedRez from "./pages/BookJavitsAdvancedRez";
import BookJavits from "./pages/BookJavits";
import BookJavits1 from "./pages/BookJavits1";
import BookJavits2 from "./pages/BookJavits2";
import BookJavits3 from "./pages/BookJavits3";
import BookJavits4 from "./pages/BookJavits4";
import BookJavits5 from "./pages/BookJavits5";
import BookJavits6 from "./pages/BookJavits6";
import JavitsB2B from "./pages/JavitsB2B";
import NotFound from "./pages/NotFound";
import ScrollToTop from "./components/ScrollToTop";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/help" element={<Help />} />
          <Route path="/book" element={<Book />} />
          <Route path="/book/PHXHyattRegencyDWT" element={<BookPHXHyattRegencyDWT />} />
          <Route path="/book/PHXHyattAdvancedrez" element={<BookPHXHyattAdvancedrez />} />
          <Route path="/book/JavitsAdvancedRez" element={<BookJavitsAdvancedRez />} />
          <Route path="/book/javits" element={<BookJavits />} />
          <Route path="/book/javits1" element={<BookJavits1 />} />
          <Route path="/book/javits2" element={<BookJavits2 />} />
          <Route path="/book/javits3" element={<BookJavits3 />} />
          <Route path="/book/javits4" element={<BookJavits4 />} />
          <Route path="/book/javits5" element={<BookJavits5 />} />
          <Route path="/book/javits6" element={<BookJavits6 />} />
          <Route path="/javits-b2b" element={<JavitsB2B />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
